import _get from 'lodash/get';

import { Base, Inspector, InspectorFee } from '@/models';
import _castArray from 'lodash/castArray';
import { toCamelCase } from '@/utilities';

export class Fee extends Base {
  public name: string;
  public description: string;
  public amount: string;
  public qty: string;
  public unitprice: string;
  public status: string;
  public location: string;
  public createdate: string;
  public contractor: string[];
  public targetdate: string;
  public completiondate: string;
  public photos: {
    in: string[],
    out: string[]
  };
  public outnotes: string;
  public inspector: InspectorFee;

  /**
   * Constructor initialises the variables from the class Fee
   * @param data - the data to construct a type with all properties of <Fee>
   */
  public constructor(data?: Partial<Fee>) {
    super(data);
    data = toCamelCase(data);
    this.name = _get(data, 'name', '');
    this.description = _get(data, 'description', '');
    this.qty = _get(data, 'qty', '');
    this.unitprice = _get(data, 'unitprice', '');
    this.amount = _get(data, 'amount', '');
    this.status = _get(data, 'status', '');
    this.createdate = _get(data, 'createdate', '');
    this.targetdate = _get(data, 'targetdate', '');
    this.completiondate = _get(data, 'completiondate', '');
    this.location = _get(data, 'location', '');
    this.photos = {
      in: _get(data, 'photos.in', []),
      out: _get(data, 'photos.out', []),
    };
    this.contractor = _castArray(_get(data, 'contractor', []));
    this.outnotes = _get(data, 'outnotes', '');
    this.inspector = new InspectorFee(_get(data, 'inspector'));
  }
  /**
  * Create a JSON representation of this object and it's descedents.
  *
  * @return {Object}
  */
   public toJSON() {
    const json = super.toJSON();
    // Convert the populated Client to the Client ID
    return {
      ...json,
      inspector: this.inspector.toJSON(),
    };
  }

}
